import { themeWorkspace } from "../../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "algebra",
    name: "%{BKY_CATALGEBRA}",
    colour: themeWorkspace.categoryStyles.algebra_category.colour,
    imageName: "/toolbox-imgs/math-operations-bold.svg",
    id: "102",
    contents: [
      {
        kind: "label",
        text: "%{BKY_LABEL_NUMBERS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "math_number",
        fields: {
          NUM: 123,
        },
      },
      {
        kind: "block",
        type: "random_number",
        fields: {
          type: "integer",
        },
        inputs: {
          min: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          max: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 100,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_constant",
        fields: {
          CONSTANT: "PI",
        },
      },
      {
        kind: "block",
        type: "math_round",
        fields: {
          OP: "ROUND",
        },
        inputs: {
          NUM: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3.1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "round_decimal",
        inputs: {
          number: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3.125,
              },
            },
          },
          decimal_digits: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "integer_decimal_part",
        fields: {
          type: "integer_part",
        },
        inputs: {
          number: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 21.345,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "split_number",
        inputs: {
          number: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 254,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_constrain",
        inputs: {
          VALUE: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 50,
              },
            },
          },
          LOW: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          HIGH: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 100,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_CALCULUS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "math_arithmetic",
        fields: {
          OP: "ADD",
        },
        inputs: {
          A: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          B: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_on_list",
        extraState: '<mutation op="SUM"></mutation>',
        fields: {
          OP: "SUM",
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_ARITHMETICS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "math_number_property",
        extraState: '<mutation divisor_input="false"></mutation>',
        fields: {
          PROPERTY: "EVEN",
        },
        inputs: {
          NUMBER_TO_CHECK: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "gcd_lcm",
        fields: {
          OP: "GCD",
        },
      },
      {
        kind: "block",
        type: "math_modulo",
        inputs: {
          DIVIDEND: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 64,
              },
            },
          },
          DIVISOR: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 10,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_FRACTIONS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "fraction",
        inputs: {
          dividend: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          divisor: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "convert_into_fraction",
        inputs: {
          number: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2.5,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "fraction_numerator_denominator",
        fields: {
          type: "numerator",
        },
      },
      {
        kind: "block",
        type: "simplify_fraction",
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_UNITS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "unit",
        inputs: {
          value: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
          unit: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "cm",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "convert_into_unit",
        inputs: {
          value: {
            block: {
              type: "unit",
              inputs: {
                value: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                unit: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "cm",
                    },
                  },
                },
              },
            },
          },
          unit: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "km",
              },
            },
          },
        },
      },
    ],
  };
}
